import { ApiService, HttpMethod } from '../_common/api.service';
import { DashApiLoginInfo } from './models/dash-api-login-info.model';
import { DashApiRefreshTokenLoginInfo } from './models/dash-api-refresh-token-login-info.model';
import { DemoLoginModel } from './models/demo-login.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Intelli360CodeLoginInfo } from './models/intelli360-code-login-info.model';
import { map } from 'rxjs/operators';
import { MyTurfCodeLoginInfo } from './models/my-turf-code-login-info.model';
import { Observable } from 'rxjs';
import { TokenKeyModel } from './models/token-key.model';

@Injectable({
    providedIn: 'root'
})
export class AuthApiService {

    private apiService: ApiService;

    // =========================================================================================================================================================
    // C'tor
    // =========================================================================================================================================================

    constructor(http: HttpClient) {
        this.apiService = new ApiService(http);
    }

    // =========================================================================================================================================================
    // Public Methods
    // =========================================================================================================================================================

    dashApiLogin(apiLoginInfo: DashApiLoginInfo): Observable<any> {
        return this.apiService.apiRequest<any>(AuthApiService.loginWithSsoInfoUrl, HttpMethod.Post, apiLoginInfo);
    }

    dashApiLoginWithRefreshToken(apiRefreshTokenLoginInfo: DashApiRefreshTokenLoginInfo): Observable<any> {
        return this.apiService.apiRequest<any>(AuthApiService.loginWithSsoInfoUrl, HttpMethod.Post, apiRefreshTokenLoginInfo);
    }

    loginWithMyTurfCode(myTurfCodeLoginInfo: MyTurfCodeLoginInfo) {
        return this.apiService.apiRequest<any>(AuthApiService.loginWithMyTurfCodeUrl, HttpMethod.Post, myTurfCodeLoginInfo);
    }

    loginWithIntelli360Code(intelli360CodeLoginInfo: Intelli360CodeLoginInfo) {
        return this.apiService.apiRequest<any>(AuthApiService.loginWithIntelli360CodeUrl, HttpMethod.Post, intelli360CodeLoginInfo);
    }

    getTrackingToken(): Observable<TokenKeyModel> {
        return this.apiService.apiRequest<any>(AuthApiService.trackingTokenUrl, HttpMethod.Get)
            .pipe(map(result => new TokenKeyModel(result)));
    }

    demoLogin(demoLoginModel: DemoLoginModel): Observable<boolean> {
        return this.apiService.apiRequest<any>(AuthApiService.demoLoginUrl, HttpMethod.Post, demoLoginModel);
    }

    // =========================================================================================================================================================
    // URLs
    // =========================================================================================================================================================

    private static get baseUrl(): string { return `${ApiService.baseApiUrl}auth`; }

    private static get loginWithSsoInfoUrl(): string { return `${AuthApiService.baseUrl}/token`; }

    private static get loginWithMyTurfCodeUrl(): string { return `${AuthApiService.baseUrl}/token`; }

    private static get loginWithIntelli360CodeUrl(): string { return `${AuthApiService.baseUrl}/token`; }

    private static get trackingTokenUrl(): string { return `${AuthApiService.baseUrl}/trackingToken`; }

    private static get demoLoginUrl(): string { return `${AuthApiService.baseUrl}/demo`; }

}
